import { render, staticRenderFns } from "./revenueSatisticsList.vue?vue&type=template&id=a227d620&scoped=true"
import script from "./revenueSatisticsList.vue?vue&type=script&lang=js"
export * from "./revenueSatisticsList.vue?vue&type=script&lang=js"
import style0 from "./revenueSatisticsList.vue?vue&type=style&index=0&id=a227d620&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a227d620",
  null
  
)

export default component.exports